import { gql } from "@apollo/client";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { TransactionRequestBuilder } from "./requestBuilder.js";
import { transactionErrorCodesMapper } from "./types.js";
class TransactionService extends EntityBaseGqlService {
  _requestBuilder;
  constructor(client, messageLocalizer) {
    const builder = new TransactionRequestBuilder();
    super(client, builder, messageLocalizer);
    this._requestBuilder = builder;
  }
  get(requestPayload) {
    return this.fetchData(requestPayload).pipe(
      map(({ responsePayload, ...response }) => {
        const query = responsePayload?.getUsersTransactions ?? responsePayload?.getFailedTransactions;
        const transactionSummaryItem = {
          uid: "transactionSummaryId",
          transaction_id: "transactionSummaryId",
          is_summary: true,
          amount: query?.total_amount,
          __typename: "Transaction"
        };
        const items = query?.total_amount ? [...query?.items ?? [], transactionSummaryItem] : query?.items;
        return {
          ...response,
          requestPayload,
          responsePayload: {
            items,
            total: items.length ? query?.total_count ?? 0 : 0
          }
        };
      })
    );
  }
  getDownloadLink(requestPayload) {
    const request = this._requestBuilder.buildDownloadRequest(requestPayload);
    return this._service.query(request.query, request.variables).pipe(
      map((response) => ({
        ...response,
        requestPayload,
        responsePayload: response?.responsePayload?.exportUsersTransactions?.url
      }))
    );
  }
  retryTransaction(transactionId) {
    return this._service.mutate(this.getRetryTransactionMutation(), {
      transaction_id: transactionId
    }).pipe(map((res) => ({ ...res, responsePayload: res?.responsePayload?.retryTransaction ?? null })));
  }
  deleteTransaction(transactionId) {
    return this._service.mutate(this.getDeleteTransactionMutation(), {
      transaction_id: transactionId
    }).pipe(map((res) => ({ ...res, responsePayload: res?.responsePayload?.deleteTransaction ?? null })));
  }
  addP2PTransfers(payload) {
    return this._service.mutate(this.getAddP2PTransferBulkOperationMutation(), { bulkData: payload }).pipe(map((res) => ({ ...res, responsePayload: res?.responsePayload?.addP2PTransferBulkOperation })));
  }
  getErrorSeverity(code) {
    const errorSeverityMapping = {
      [transactionErrorCodesMapper.yearAndHistoricalDoesNotMatch]: 2,
      [transactionErrorCodesMapper.yearAndStartedTsYearDoesNotMatch]: 2
    };
    return errorSeverityMapping[code];
  }
  getRetryTransactionMutation() {
    return gql`
            mutation RetryTransaction($transaction_id: String!) {
                retryTransaction(transaction_id: $transaction_id) {
                    transaction_id
                }
            }
        `;
  }
  getDeleteTransactionMutation() {
    return gql`
            mutation DeleteTransaction($transaction_id: String!) {
                deleteTransaction(transaction_id: $transaction_id) {
                    transaction_id
                }
            }
        `;
  }
  getAddP2PTransferBulkOperationMutation() {
    return gql`
            mutation AddP2PTransferBulkOperation($bulkData: BulkMutationInput!) {
                addP2PTransferBulkOperation(bulkData: $bulkData) {
                    id
                }
            }
        `;
  }
}
export {
  TransactionService
};
//# sourceMappingURL=service.js.map
